import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Button, Input } from 'reactstrap';
import { Dispatch } from 'redux';
import { Applications, Groups, Users, Workspace } from '../../clients/aasServerClient.generated';
import { getApplicationName } from '../../stores/applications/selectors';
import { hideGroups } from '../../stores/auth/selectors';
import { getGroupName } from '../../stores/groups/selectors';
import { RootState } from '../../stores/store';
import { select, unselect } from '../../stores/tables/actionCreators';
import { isSelected } from '../../stores/tables/selectors';
import { getUserName } from '../../stores/users/selectors';
import { deleteWorkspaces } from '../../stores/workspaces/actionCreators';
import { getWorkspaceName } from '../../stores/workspaces/selectors';
import ConfirmModal from '../common/modals/ConfirmModal';

interface Props extends LocalizeContextProps, RouteComponentProps {
    workspace: Workspace;
    selected: boolean;
    getApplicationName: (id: string) => string;
    getGroupName: (id: string) => string;
    getUserName: (id: string) => string;
    getWorkspaceName: (id: string) => string;
    hideGroups?: boolean;

    select: (id: string) => void;
    unselect: (id: string) => void;
    delete: (id: string) => void;
}

interface State {
    showDelete: boolean;
}

class WorkspacesTableRow extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);
        this.state = {
            showDelete: false,
        };
    }

    public render() {
        const t = this.props.translate;
        const workspace = this.props.workspace;
        return (
            <tr
                className={classnames('table-row', this.props.selected ? 'selected' : '')}
                onClick={(e) => {
                    this.props.selected ?
                        this.props.unselect(workspace.id) : this.props.select(workspace.id);
                }}
            >
                <td ><Input type="checkbox" checked={this.props.selected} onChange={() => null} /></td>
                <td>{workspace.name}</td>
                <td>{this.getWorkspaceCell(workspace.parent?.id)}</td>
                <td>{workspace.user_limit}</td>
                <td>{this.getnumCell(workspace.app_count)}</td>
                {this.props.hideGroups === false ? <td>{this.getGroupCell(workspace.groups)}</td> : null}
                <td>{this.getnumCell(workspace.user_count) }</td>
                <td className="icon-btn-td">
                    <Button
                        color="primary"
                        onClick={(e) => {
                            e.stopPropagation();
                            this.props.history.push('/workspaces/edit/' + this.props.workspace.id);
                        }}
                    >
                        <FontAwesomeIcon icon={['fal', 'pencil']} className="noMarginRight" />
                    </Button>
                </td>
                <td className="icon-btn-td">
                    <Button
                        color="danger"
                        onClick={(e) => {
                            e.stopPropagation();
                            this.setState({ showDelete: true });
                        }}
                    >
                        <FontAwesomeIcon icon={['fal', 'trash']} className="noMarginRight" />
                    </Button>
                    <ConfirmModal
                        header={t('workspaces.modal.delete.header') as string}
                        confirmText={t('workspaces.modal.delete.delete') as string}
                        isOpen={this.state.showDelete}
                        buttonColor="danger"
                        cancel={() => this.setState({ showDelete: false })}
                        confirm={() => this.props.delete(this.props.workspace.id)}
                    >
                        {`${t('workspaces.modal.delete.text')} ${this.props.workspace.name || this.props.workspace.id}`}
                    </ConfirmModal>
                </td>
            </tr>
        );
    }

    private getnumCell = (apps?: string) => {
        if (apps === undefined || apps.length === 0) {
            return '';
        } else if (+(apps)  ) {
            return this.props.translate('workspaces.table.cells.assigned', { number: apps  });
        } else {
            return apps;
        }
    }

    

    private getGroupCell = (groups?: Groups[]) => {
        if (groups === undefined || groups.length === 0) {
            return '';
        } else if (groups.length > 1) {
            return this.props.translate('workspaces.table.cells.assigned', { number: groups.length });
        } else {
            return this.props.getGroupName(groups[0].id);
        }
    }

    private getUserCell = (users?: Users[]) => {
        if (users === undefined || users.length === 0) {
            return '';
        } else if (users.length > 1) {
            return this.props.translate('workspaces.table.cells.assigned', { number: users.length });
        } else {
            return this.props.getUserName(users[0].id);
        }
    }

    private getWorkspaceCell = (workspaceId?: string) => {
        if (workspaceId === undefined) {
            return '';
        } else {
            return this.props.getWorkspaceName(workspaceId);
        }

    }
}

const mapStateToProps = (state: RootState, props: { workspace: Workspace }) => ({
    getApplicationName: getApplicationName(state),
    getGroupName: getGroupName(state),
    getUserName: getUserName(state),
    getWorkspaceName: getWorkspaceName(state),
    hideGroups: hideGroups(state),
    selected: isSelected(state, 'workspaces', props.workspace.id),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    delete: (id: string) => dispatch(deleteWorkspaces([id])),
    select: (id: string) => dispatch(select('workspaces', id)),
    unselect: (id: string) => dispatch(unselect('workspaces', id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withLocalize(WorkspacesTableRow)));